var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcAppContentDetails',[(_vm.loading('collective') || _vm.loading('currentPage'))?_c('div',{staticClass:"sheet-view"},[_c('SkeletonLoading',{staticClass:"page-heading-skeleton",attrs:{"count":1,"type":"page-heading"}})],1):(_vm.currentPage && _vm.version)?_c('Version'):(_vm.currentPage)?_c('Page'):_c('PageNotFound')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }